export function setTimeSince(time) {
    return {
        type: 'SET_TIME_SINCE',
        payload: time
    }
}

export function setGender(gender) {
    return {
        type: 'SET_GENDER',
        payload: gender
    }
}

export function setKaiser(value) {
    return {
        type: 'SET_KAISER',
        payload: value
    }
}

export function setFpact(value) {
    return {
        type: 'SET_FPACT',
        payload: value
    }
}


// WEBPACK FOOTER //
// ./src/actions/userActions.js